<template>
    <!-- <el-amap class="amap-box" :vid="'amap'" :scrollWheel="true" :center="center" :plugin="plugins" :mapStyle="mapStyle"> </el-amap> -->
    <div  v-loading="loading"
        element-loading-text="正在加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 9, 58)" class="amap-box" id="amap"  @contextmenu.prevent.stop="rightClick($event)">
    </div>
</template>

<script>
import util from "@/util";
import store from "@/store";
import { mapState } from "vuex";
import { Backtop } from "element-ui";
import xinjianmapdata from '@/mockdata/xinjianmapdata.json'
import china from '@/mockdata/china.json'
function showInfoM(e){
	console.log("点击")
}
function showInfoP(e){
	console.log("点击")
}
function createInfoWindow(title, content,callback) {
    // console.log(content)
	var info = document.createElement("div");
    info.className = "custom-info input-card content-window-card";

    //可以通过下面的方式修改自定义窗体的宽高
    info.style.width = "350px";
    // 定义顶部标题
    var top = document.createElement("div");
    top.style.padding = "2px 3px"
    top.style.backgroundColor = "#05073a";
    top.style.color = "#fff"
    top.style.fontSize = "15px"
    top.style.display = "flex"
    top.style.justifyContent = "center"
    top.style.alignItems = "center"
    top.style.borderTopLeftRadius = "10px"
    top.style.borderTopRightRadius = "10px"
    var titleD = document.createElement("div");
    // var closeX = document.createElement("img");
    top.className = "info-top";
    
    // closeX.src = require("@/assets/close.png");
    // closeX.onclick = callback;

    top.appendChild(titleD);
    top.innerHTML = title;
    // top.appendChild(closeX);
    info.appendChild(top);

    // 定义中部内容
    var middle = document.createElement("div");
    middle.className = "info-middle";
    middle.style.backgroundColor = "white";
    middle.style.padding = "5px"
    middle.innerHTML = content;
    info.appendChild(middle);

    // 定义底部内容
    var bottom = document.createElement("div");
    bottom.className = "info-bottom";
    bottom.style.position = "relative";
    bottom.style.top = "0px";
    bottom.style.margin = "0 auto";
    info.appendChild(bottom);
    return info;
}

export default {
    computed: {
        ...mapState(["siteInfo","connectorInfo","user"]),
    },
    data () {
        return {
            loading: true,
            center: [115.904539, 28.686507],
            plugins: ['MapType','Scale','ToolBar','Geolocation'],
            map: null,
            mapStyle: "amap://styles/dark", //修改地图的背景颜色
			infoWindow: null,
			pointList: [
				{
					address: "美森宝-西湖区远景大厦停车场",
					local: [115.887, 28.6661],
				},
				{
					address: "美森宝-青山湖区溪湖春天小区",
					local: [115.98, 28.6638],
				},
				{
					address: "美森宝-西湖区直冲街润门街办",
					local: [115.886, 28.6718],
				},
				{
					address: "美森宝-江西省税务局",
					local: [115.827, 28.6337],
				},
			],
			winInfo: [],
			winTitle: "",
			markList: [],
            stations: [],
        }
    },
    created() {
        
    },
    async mounted() {
        await this.getSite()
		this.initMap()
    },
    methods: {
		setCenter(site) {
			// console.log(site.siteId)
			let siteId = site.siteId;
			console.log(this.siteInfo)
			for(let i = 0;i<this.siteInfo.length;i++) {
				if(siteId === this.siteInfo[i].id) {
					this.map.setZoomAndCenter(17,[this.siteInfo[i].lng, this.siteInfo[i].lat])
					this.hideSearch()
				}
			}
			// this.map.setCenter([lng, lat]);
		},
		rightClick(e) {
			// console.log(e)
			// this.itemLeft = e.clientX + 'px';
			// this.itemtop = e.clientY + 'px';
			// console.log(e.clientX)
			// console.log(e.clientY)
			this.$emit('clickRight', {
				clientX: e.clientX,clientY:e.clientY
			});
		},
		hideSearch() {
			this.$emit('hideSearch', {});
		},
        async getSite() {
            let postData = {
                from: 0,
                limit: 100000,
            };
            await store.dispatch("getSite", postData);
            let stations = JSON.parse(JSON.stringify(this.siteInfo))
            console.log(stations)
            this.stations = stations
            let promiseArr = [];
            for (let i = 0; i < stations.length; i++) {
                let postData2 = {
                    station_id: stations[i].id,
                };
                await store.dispatch("getConnector", postData2);
                let promise = new Promise((resolve, reject) => {
                    resolve(this.connectorInfo);
                });
                promiseArr.push(promise);
            }
            Promise.allSettled(promiseArr)
                .then(result => {
                    for (let i = 0; i < stations.length; i++) {
                        stations[i].chargingNums = 0;
                        stations[i].freeNums = 0;
                        stations[i].offlineNums = 0;
                        stations[i].faultNums = 0;
                        for (let j = 0; j < result[i].value.length; j++) {
                            if (result[i].status === "fulfilled") {
                                if (result[i].value[j].status === 2) {
                                    stations[i].chargingNums += 1;
                                } else if (result[i].value[j].status === 1) {
                                    stations[i].freeNums += 1;
                                } else if (result[i].value[j].status === 0) {
                                    stations[i].offlineNums += 1;
                                } else if (
                                    result[i].value[j].status === 255 ||
                                    result[i][j].status === 254
                                ) {
                                    stations[i].faultNums += 1;
                                }
                            } else {
                                console.log(result[i]);
                            }
                        }
                    }
                    for (let i = 0; i < stations.length; i++) {
                        stations[i].chargingNums = stations[i].chargingNums.toString();
                        stations[i].freeNums = stations[i].freeNums.toString();
                        stations[i].offlineNums = stations[i].offlineNums.toString();
                        stations[i].faultNums = stations[i].faultNums.toString();
                    }
                    // console.log(stations)
                    this.stations = stations
                    this.initMap();
                })
                .catch(error => {
                    console.log(error);
                    util.ShowTip(error, 2);
                });
        },
		async initMap() {
            let self = this;
            this.map = new AMap.Map("amap", {
                // mapStyle: 'amap://styles/57753e113de2efca09d5b643fc231f5f',
                mapStyle:"amap://styles/graffiti",
                resizeEnable: true,
                zoom: 9, //级别
                center: [this.stations[0].lng ? this.stations[0].lng : 115.904539,this.stations[0].lat ? this.stations[0].lat : 28.686507], //中心点坐标
                viewMode: "3D", //使用3D视图
            }); //初始化地图
            // this.map.addControl(new AMap.Scale());       // 添加比例尺插件
            this.map.addControl(new AMap.ToolBar());     // 添加类型插件
            this.map.addControl(new AMap.MapType());     // 添加工具条插件
            this.map.addControl(new AMap.Geolocation()); // 添加定位插件
            this.map.addControl(new AMap.Scale());
            this.map.addControl(new AMap.MarkerClusterer())
            this.map.addControl(new AMap.Icon())
			this.map.addControl(new AMap.Polygon())
            //点击地图外清楚信息窗体
			this.initPolygon();
            this.map.on('click', function (e) {
                console.log("点击地图")
                self.map.clearInfoWindow();
				self.hideSearch()
            });
            var markers = []
            //遍历生成多个标记点
            // let postData = {
            //     from: 0,
            //     limit: 100000,
            // };
            // await store.dispatch("getSite", postData);
            // let stations = JSON.parse(JSON.stringify(this.siteInfo))
            // console.log(stations)
            let stations = JSON.parse(JSON.stringify(this.stations))
            // console.log(stations)
            for (var i = 0, marker; i < stations.length; i++) {
                var startIcon = new AMap.Icon({
                    // 图标尺寸
                    size: new AMap.Size(50, 50),
                    // 图标的取图地址
                    image: require('../assets/Station/site.png'),
                    // 图标所用图片大小
                    imageSize: new AMap.Size(40, 40),
                    // 图标取图偏移量
                    // imageOffset: new AMap.Pixel(-5, 0)
                });
                let strimg = require('@/assets/map-content.png');
                var markerContent = 
                            '<div style="background-image:url('+strimg+');background-size: 100% 100%;padding: 0 0.5rem 0.3rem 0;min-width: 5rem;height: 2.8rem;display: flex;flex-direction: row;justify-content: space-between;align-items: center;">' +
                                '<div style="heigth: 2rem;min-width: 3.5rem;display: flex;flex-direction: row;justify-content: center;align-items: center">' +
                                    '<svg t="1677054106734" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5523" width="30" height="30"><path d="M512 64.32L288.05 512.44l222.61 111.81-110.63 335.43 335.92-447.24-225.29-111.81z" fill="#FFD500" p-id="5524"></path></svg>'+
                                    '<div style="color:#fff">'+stations[i].chargingNums+
                                    '</div>'+
                                '</div>'+
                                '<div style="heigth: 2rem;min-width: 3.5rem;display: flex;flex-direction: row;justify-content: center;align-items: center">' +
                                    '<svg t="1677054106734" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5523" width="30" height="30"><path d="M512 64.32L288.05 512.44l222.61 111.81-110.63 335.43 335.92-447.24-225.29-111.81z" fill="#95de64" p-id="5524"></path></svg>'+
                                    '<div style="color:#fff">'+stations[i].freeNums+
                                    '</div>'+
                                '</div>'+
                            '</div>'; //设置文本标注内容
                var marker = new AMap.Marker({
                    position: [stations[i].lng,stations[i].lat], //不同标记点的经纬度
                    map: self.map,
                    // icon: startIcon,
                    content: markerContent,
                    // 以 icon 的 [center bottom] 为原点
                    // offset: new AMap.Pixel(-13, -30)
                });
                
                marker.title = `<span>`+`(`+stations[i].area_code+`)`+stations[i].name+`</span>`;
                marker.content = JSON.stringify([
                    // "<div>状态；"+this.siteStatus(stations[i].status)+"</div>",
                    "<div>地址："+stations[i].address+"</div>",
                    "<div>充电中："+stations[i].chargingNums+"</div>",
                    "<div>空闲："+stations[i].freeNums+"</div>",
                    "<div>故障："+stations[i].faultNums+"</div>",
                    "<div>离线："+stations[i].offlineNums+"</div>",
                    // "<div style='display:flex;flex-direction: row;justify-content: space-between;'><span style='width:50%'>空闲：5</span><span style='width:50%'>离线：2</span></div>",
                    // "<div style='display:flex;flex-direction: row;justify-content: space-between;'><span style='width:50%'>占用：5</span><span style='width:50%'>故障：2</span></div>",
                ]);
                //地图上显示站点名称
                // marker.setLabel({
                //     offset: new AMap.Pixel(-5, -10),  //设置文本标注偏移量
                //     content: "<div style='color:#00093a;'>"+stations[i].name+"</div>", //设置文本标注内容
                //     direction: 'top' //设置文本标注方位
                // });
                markers.push(marker)
                marker.on("click", self.markerClick);
                
                // marker.emit("click", { target: marker }); //默认初始化不出现信息窗体,打开初始化就出现信息窗体
            }
            //实例化信息窗体
            this.infoWindow = new AMap.InfoWindow({
                isCustom: true, //使用自定义窗体
                content: self.winInfo,
                offset: new AMap.Pixel(50, -45),
                autoMove: true,
                // closeWhenClickMap: true
            });
            //点聚合
            var cluster = new AMap.MarkerClusterer(this.map, markers, { gridSize: 80, minClusterSize:3 })
            // this.map.setFitView();
        },
        // 点标记点击事件
        markerClick(e) {
            console.log(e)
            let self = this;
            this.winInfo = JSON.parse(e.target.content);
            this.winTitle = e.target.title;
            // 设置窗体内容
            this.infoWindow.setContent(
                createInfoWindow(
                    self.winTitle,
                    self.winInfo.join(""),
                    function () {
                        // 关闭窗体
                        self.map.clearInfoWindow();
                    }
                )	
            );
            // 打开窗体
            self.infoWindow.open(self.map, e.target.getPosition());
        },
        /*站点状态*/
        siteStatus(num) {
            let status = [
                //状态
                { id: "0", text: "未知",},
                { id: "1", text: "建设中", },
                { id: "5", text: "关闭下线", },
                { id: "6", text: "维护中", },
                { id: "50", text: "正常",  },
            ]
            let value = "";
            status.forEach((val, index) => {
                if (val.id == Number(num)) {
                    value = val.text;
                }
            });
            return value;
        },
		//区域遮盖 只显示新建区
		initPolygon (city) {
		    var that =this
		    if( that.polygon ) {
		        that.map.remove(that.polygon)
		    }
		    new AMap.plugin('AMap.DistrictSearch', function () {
		        new AMap.DistrictSearch({
		            extensions: 'all',
		            subdistrict: 2,
		            level: 'district',
		        }).search(city, function(status, result) {// 外多边形坐标数组和内多边形坐标数组
		            var outer = [
		                new AMap.LngLat(-360, 90, true),
		                new AMap.LngLat(-360, -90, true),
		                new AMap.LngLat(360, -90, true),
		                new AMap.LngLat(360, 90, true)
		            ]
		            var holes = xinjianmapdata.features[0].geometry.coordinates[0];
		            var holesChina = china.features[0].geometry.coordinates[0];
		            var pathArray = [outer]
		            if(that.user.mobile === "xinjian") {
		                pathArray.push.apply(pathArray, holes)
		            }else {
		                pathArray.push.apply(pathArray, holesChina)
		            }
		            // pathArray.push.apply(pathArray, holes)
		            that.polygon = new AMap.Polygon({
		                pathL: pathArray,
		                strokeColor: 'red',//城市边界颜色
		                strokeWeight: 1,
		                fillColor: '#00093a', // 遮罩背景色黑色
		                fillOpacity: 1
		            })
		            that.polygon.on('click', function (e) {
		                that.map.clearInfoWindow();
		            });
		            that.polygon.setPath(pathArray)
		            that.map.add(that.polygon)
					that.loading = false
		        })
		    })
		},
    },
}
</script>

<style lang="scss" scoped>
.amap-box {
  width: 100%;
  height: 100%;
}
::v-deep .amap-marker-label {
    border: none;
    background-color: #fff;
    // color: blue;
    // border-radius: 15%;
    // position: absolute;
    // z-index: 2;
    // border: 1px solid blue;
    // /* background-color: white; */
    // white-space: nowrap;
    // cursor: default;
    // padding: 3px;
    // font-size: 12px;
    // line-height: 14px;
}
.markerContent {
    min-width: 5rem;
    height: 3rem;
    display: flex;
    flex-direction: row-reverse;
    // justify-content: center;
    justify-content: space-between;
    align-items: center;
    background-color: red;
}
.info{
    background-color: red;
}

.item {
	position: absolute;
	left: 1rem;
	top: 1rem;
	width: 7rem;
	height: 3rem;
	background-color: red;
	z-index: 10000;
}

</style>